import BranchSummaryReportTypes from './branch-summary-report.types';

/** ***************** BranchSummary DETAILS START *********************** */
export const fetchBranchSummaryReportStart = (addData: any) => ({
	type: BranchSummaryReportTypes.FETCH_BRANCH_SUMMARY_REPORT_START,
	payload: addData,
});

export const fetchBranchSummaryReportSuccess = (successData: any) => ({
	type: BranchSummaryReportTypes.FETCH_BRANCH_SUMMARY_REPORT_SUCCESS,
	payload: successData,
});

export const fetchBranchSummaryReportFailure = (failureData: any) => ({
	type: BranchSummaryReportTypes.FETCH_BRANCH_SUMMARY_REPORT_FAILURE,
	payload: failureData,
});

export const fetchBranchSummaryReportResponseResetStart = () => ({
	type: BranchSummaryReportTypes.FETCH_BRANCH_SUMMARY_REPORT_RESPONSE_RESET_START,
});

export const fetchBranchSummaryReportResponseResetChanged = () => ({
	type: BranchSummaryReportTypes.FETCH_BRANCH_SUMMARY_REPORT_RESPONSE_CHANGED,
});

/** ***************** FETCH BranchSummary DETAILS END *********************** */
